import { getWxconfig } from '@/api/public.js'
let wx = require('weixin-js-sdk');
export function wxShare(title,openid,_this) {
	getWxconfig({url:encodeURIComponent(window.location.href.split('#')[0]),openid:openid}).then(function(res){
		console.log("=============================1")
		console.log(res)
		// 微信支付使用
		localStorage.setItem('wxdata',JSON.stringify(res.data));
		if(_this){
			//舆情秘书对应appid
			if(res.data.appId=='wx271a17fac4c5becb' || res.data.appId=='wx641f544aa3542a0d' || res.data.appId=='wx3622951048307d19' || res.data.appId=='wx2dfc71f0195eedcd' || res.data.appId=='wxce06c13ea09c1d7c'){
				_this.yqmsorigin = true;
			}else{//非秘书
				_this.yqmsorigin = false;
			}
		}
		console.log(res)
		wx.config({
			debug: false, //开启debug模式，在验证签名过程中会返回对应信息
			appId: res.data.appId,
			timestamp: res.data.timestamp,
			nonceStr: res.data.nonceStr,
			signature: res.data.signature,
			jsApiList: [
				'updateAppMessageShareData',
				'updateTimelineShareData',
				'onMenuShareTimeline',
				'onMenuShareAppMessage',
				'onMenuShareQQ',
				'hideMenuItems',
				'onMenuShareQZone'
		]
		}) 
		wx.error(function(res){
			// config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
			console.log(res)
		});
		wx.ready(function () {   //需在用户可能点击分享按钮前就先调用 
			wx.hideMenuItems({
				menuList: [
					"menuItem:copyUrl", // 复制链接
					"menuItem:originPage",
					"menuItem:openWithQQBrowser",
					"menuItem:openWithSafari"
				]});
			let urlStr = window.location.href.split('#')[0] 
			if(urlStr.indexOf('&isAuthorised=1') == -1){
				urlStr = urlStr+'&isAuthorised=1'
			}
			if(wx.updateAppMessageShareData){
				wx.updateAppMessageShareData({ 
					title: title, // 分享标题
					desc: '', // 分享描述
					link: urlStr, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
					imgUrl: 'http://www.ewrwefg.com/nas/img/share.png', // 分享图标
					success: function () {
					// 设置成功
					}
				})
			}else{
				wx.onMenuShareAppMessage({
					title: title, // 分享标题
					desc: '', // 分享描述
					link: urlStr, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
					imgUrl: 'http://www.ewrwefg.com/nas/img/share.png', // 分享图标
					type: '', // 分享类型,music、video或link，不填默认为link
					dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
					success: function () {
					// 用户点击了分享后执行的回调函数
					}
				});
			}
			if(wx.updateTimelineShareData) {
				wx.updateTimelineShareData({ 
					title: title, // 分享标题
					link: urlStr, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
					imgUrl: 'http://www.ewrwefg.com/nas/img/share.png', // 分享图标
					success: function () {
					// 设置成功
					}
				})
			}else{
				wx.onMenuShareTimeline({
					title: title, // 分享标题
					link: urlStr, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
					imgUrl: 'http://www.ewrwefg.com/nas/img/share.png', // 分享图标
					success: function () {
					// 用户点击了分享后执行的回调函数
					}
				})
			}
		});
	});
}
